export default {
    listUserSignature: state => state.listUserSignature,
  }